import { getDocs, orderBy, query, where } from "firebase/firestore";
import { dataCollection, porteLogsCollection } from "../../config/firebaseConfig";

export const getWeekDifference = (startDate, endDate) => {
    // Calculate the difference in milliseconds
    const diffInMs = Number(endDate - startDate);

    // Convert milliseconds to weeks
    const diffInWeeks = diffInMs / (1000 * 60 * 60 * 24 * 7);

    if (diffInWeeks < 2) {
        return 0;
    } else if (diffInWeeks >= 2 && diffInWeeks < 4) {
        return 1;
    } else if (diffInWeeks >= 4 && diffInWeeks < 8) {
        return 2;
    } else {
        return 3;
    }
}

export const getConvertedDates = (startDate, endDate) => {
    return {
        convertedDateStart: new Date(startDate).getTime(),
        convertedDateEnd: new Date(endDate).getTime(),
    };
};

export const fetchData = async (startDate, endDate, chambre,) => {
    try {
        // console.log("fetchData :", startDate, endDate, chambre);
        let q = query(
            dataCollection,
            where("time", ">=", Number(startDate)),
            where("time", "<=", Number(endDate)),
            where("chambre", "==", String(chambre)),
            orderBy("time"),
        );

        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => doc.data());

        return data
    } catch (error) {
        // console.log("Error in fetching data", error);
    }
};

export const fetchPortsData = async (startDate, endDate, chambre) => {
    try {
        // console.log("fetchPortsData :", startDate, endDate, chambre);

        const q = query(
            porteLogsCollection,
            where("date", ">=", Number(startDate)),
            where("date", "<=", Number(endDate)),
            where("chambre", "==", String(chambre))
        );
        const querySnapshotPorts = await getDocs(q);
        const portsData = querySnapshotPorts.docs.map((doc) => doc.data());
        return portsData;
    } catch (error) {
        // console.log("Error in fetching Port data", error);
    }
};

export const processData = (data, step) => {
    let timeArr = [];
    let co2CSV = [];
    let humiditeCSV = [];
    let ethyleneCSV = [];
    let temperatureCSV = [];

    let co2Arr = [];
    let humiditeArr = [];
    let ethyleneArr = [];
    let temperatureArr = [];

    let co2SeuilArr = [];
    let humiditeSeuilArr = [];
    let ethyleneSeuilArr = [];
    let temperatureSeuilArr = [];

    let allTimeArr = [];
    let allCo2Arr = [];
    let allHumArr = [];
    let allTemprArr = [];
    let allEthArr = [];

    for (let n = 0; n < data.length; n = n + step) {
        const formattedDate = formatDateTime(new Date(data[n].time));
        timeArr.push(formattedDate);
        co2CSV.push(data[n].co2);
        humiditeCSV.push(data[n].humidite);
        ethyleneCSV.push(data[n].ethylene);
        temperatureCSV.push(data[n].temperature);

        co2Arr.push([data[n].time, data[n].co2]);
        humiditeArr.push([data[n].time, data[n].humidite]);
        ethyleneArr.push([data[n].time, data[n].ethylene]);
        temperatureArr.push([data[n].time, data[n].temperature]);

        co2SeuilArr.push([data[n].time, data[n].co2Consigne]);
        humiditeSeuilArr.push([data[n].time, data[n].humConsigne]);
        ethyleneSeuilArr.push([data[n].time, data[n].ethConsigne]);
        temperatureSeuilArr.push([data[n].time, data[n].tempConsigne]);

        allTimeArr.push(formattedDate);
        allCo2Arr.push(data[n].co2);
        allHumArr.push(data[n].humidite);
        allTemprArr.push(data[n].temperature);
        allEthArr.push(data[n].ethylene);
    }

    return {
        co2: co2Arr,
        humidite: humiditeArr,
        ethylene: ethyleneArr,
        temperature: temperatureArr,
        time: timeArr,

        co2Export: co2CSV,
        tempExport: temperatureCSV,
        ethExport: ethyleneCSV,
        humExport: humiditeCSV,

        allTime: allTimeArr,
        allCo2: allCo2Arr,
        allHum: allHumArr,
        allTempr: allTemprArr,
        allEth: allEthArr,

        co2Seuil: co2SeuilArr,
        humiditeSeuil: humiditeSeuilArr,
        ethyleneSeuil: ethyleneSeuilArr,
        temperatureSeuil: temperatureSeuilArr,
    };
};


const formatDateTime = (date) => {

    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();

    // Ensure two-digit formatting
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    
    return `${day}/${month}/${year}, ${hours}:${minutes}`;
};

export const processPortsData = (portsData) => {
    let newArr = [];

    try {
        let portsOnOffArr = portsData.map((port) => [port.date, port.status]);

        if (portsOnOffArr[0][1] === "off") {
            portsOnOffArr.shift();
        }
        if (portsOnOffArr.length % 2 !== 0) {
            portsOnOffArr.pop();
        }

        let mergedArr = [];
        let lastEntry = null;
        const mergeThreshold = 10 * 60 * 1000; // 10 minutes in milliseconds

        for (let i = 2; i <= portsOnOffArr.length; i += 2) {
            let start = new Date(portsOnOffArr[i - 2][0]).getTime();
            let end = new Date(portsOnOffArr[i - 1][0]).getTime();

            if (lastEntry && start - lastEntry.x2 <= mergeThreshold) {
                // Merge with the previous annotation
                lastEntry.x2 = end;
            } else {
                // Create a new annotation
                lastEntry = {
                    x: start,
                    x2: end,
                    fillColor: "#F39C12",
                };
                mergedArr.push(lastEntry);
            }
        }
        return mergedArr;

    } catch (error) {
        return [];
    }
};